/*global FB */
export const checkStatus = (methodType, activity) => {
  let ret
  try {
    if (typeof (FB) !== undefined && FB !== null) {

      FB.getLoginStatus(
        (response) => {
          ret = statusChangeCallback(response, methodType, activity);
        }
      )
    } else {
      console.log("FB is not available yet");
    }
    return ret
  } catch (e) {
    console.log(e);
  }
}

function statusChangeCallback(response, methodType, activity) {
  let retrunRes = ""
  if (response.status === 'connected') {
    console.log('connected', response);
    if (methodType === "post") {
      postOnFB(response);
      retrunRes = DoAPICalls(response);
      console.log("done post");
    } else {
      retrunRes = DoAPICalls(response);
      console.log("no post");
    }
  } else if (response.status === 'not_authorized') {
    console.log("'not_authorized'");
    FB.login(
      (response) => {
        if (response.authResponse) {
          console.log("welcome to facebook");
          retrunRes = DoAPICalls(response);
          if (methodType === "post") {
            postOnFB(response);
          }
        } else {
          console.log("cancelled login")
        }
      },
      { scope: 'public_profile,user_birthday,user_gender' }//user_likes-> add this for posting
    )
  } else {
    console.log("use is loged out of both accounts");
    FB.login(
      (response) => {
        if (response.authResponse) {
          console.log("welcome to facebook")
          retrunRes = DoAPICalls(response);
        } else {
          console.log("cancelled login")
        }
      },
      { scope: 'public_profile,user_birthday,user_gender' }//user_likes-> add this for posting// user_age_range
    )
  }
  return retrunRes
}

const removeCookies = () => {
  console.log("remove cookies");
  let cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    let eqPos = cookie.indexOf("=");
    let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}

export const logout = () => {
  let FBUserInfo = localStorage.getItem("FB_user_info");
  if (FBUserInfo && FBUserInfo !== "null") {
    localStorage.setItem("FB_user_info", null);
    localStorage.setItem("user_profile", null);
    try {
      if (typeof (FB) !== undefined && FB !== null) {
        FB.getLoginStatus(
          (response) => {
            if (response.status === 'connected') {
              console.log("it is connected")
              FB.logout(function (response) {
                //alert("logged out.");
                //FB.Auth.setAuthResponse(null, 'unknown');
                removeCookies();
                document.location.reload();
              });
            }
          }
        )
      }
    } catch (e) {
      console.log(e);
    }
  } else {
    console.log("we are not logged In");
  }
}

const DoAPICalls = (response) => {
  let checkForNewSession = sessionStorage.getItem("NewSession");
  let FBUserInfo = localStorage.getItem("FB_user_info");
  let profilePic = localStorage.getItem("user_profile");
  let returnObject
  //!FBUserInfo && FBUserInfo === "null"
  if (!FBUserInfo || FBUserInfo === "null") {
    FB.api(
      `/me/`,
      'get',
      { "fields": "first_name,name,birthday,gender,age_range" },
      (response) => {
        if (response) {
          response = JSON.stringify(response);
          localStorage.setItem("FB_user_info", response);
          returnObject = {
            ...returnObject,
            profileData: response
          }
        }
        console.log("api response", response);
      }
    );
  } else {
    console.log("FBUserInfo", FBUserInfo);
    returnObject = {
      ...returnObject,
      profileData: FBUserInfo
    }
  }

  if (!checkForNewSession || !profilePic || profilePic === "null") {
    sessionStorage.setItem("NewSession", true);
    console.log("checkForNewSession", checkForNewSession, profilePic)
    FB.api(
      `/me/picture?redirect=false`,
      'get',
      {
        "height": "200",
        "type": "normal",
        "width": "200"
      },
      (res) => {
        if (res.data) {
          console.log("pic response", res);
          localStorage.setItem("user_profile", res.data.url);
          returnObject = {
            ...returnObject,
            profilePic: res.data.url
          }
        } else {
          console.log("error while making api call");
        }
      }
    )
  } else {
    console.log("we have a picture no need to fetch from facebook", profilePic);
    returnObject = {
      ...returnObject,
      profilePic: profilePic
    }
  }

  return returnObject
}
/* FB.api(
   `/${response.authResponse.userID}/music`,
   function (response) {
     if (response && !response.error) {
     console.log("music",response)
     }
   }
);

*/

const postOnFB = (response) => {
  FB.ui({
    method: 'feed',
    link: 'https://www.w3schools.com/jsref/tryit.asp?filename=tryjsref_indexof'
  }, (response) => {
    console.log("post on facebook", response)
  });
}